import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Icon, Menu } from 'antd';

// eslint-disable-next-line prefer-destructuring
const Item = Menu.Item;

const ActionsMenu = (props) => {
  const { status } = props;

  const handleOnClick = (e = { key: '' }) => {
    props.onClick({
      current: e.key, id: props.id, expired: props.expired, postId: props.postId,
    });
  };

  const MenuItems = (expired) => (
    <Menu onClick={handleOnClick}>
      <Item key="preview">
        <span>
          <Icon type="eye" />
          <span>Preview</span>
        </span>
      </Item>
      <Item key={status === 'trash' ? 'restore' : 'delete'}>
        <span>
          <Icon type="delete" />
          <span>{status === 'trash' ? 'Restaurar' : 'Papelera'}</span>
        </span>
      </Item>
      <Item key={expired ? 'recover' : 'expire'}>
        <span>
          <Icon type="clock-circle" />
          <span>{expired ? 'Recuperar' : 'Expirar'}</span>
        </span>
      </Item>
    </Menu>
  );

  return (
    <Dropdown className="actions-menu-dropdown" overlay={() => MenuItems(props.expired)}>
      <Icon type="more" />
    </Dropdown>
  );
};

ActionsMenu.propTypes = {
  onClick: PropTypes.func.isRequired,
  expired: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  postId: PropTypes.number.isRequired,
};

export default ActionsMenu;
